import { useEffect, useRef, useState } from "react";
import dayjs, { Dayjs } from "dayjs";

type Props = {
  run?: boolean;
  duration: number; //in seconds
  onStart?: (startTime?: Dayjs) => void;
  onTimerCompleted?: () => void;
};

const Timer = ({ run, duration, onStart, onTimerCompleted }: Props) => {
  const [time, setTime] = useState<{
    hour: number;
    minute: number;
    second: number;
  }>({
    hour: 0,
    minute: 0,
    second: 0,
  });

  const startTime = useRef<null | Dayjs>(null);

  useEffect(() => {
    if (run) {
      startTime.current = dayjs();

      if (onStart) {
        onStart(startTime?.current);
      }

      const id = setInterval(() => {
        const currentDuration = dayjs().diff(startTime.current, "second") ?? 0;

        if (currentDuration == duration) {
          if (onTimerCompleted) onTimerCompleted();
        }

        setTime({
          hour: Math.floor(currentDuration / 3600),
          minute: Math.floor(currentDuration / 60),
          second: currentDuration % 60,
        });
      }, 1000);
      return () => clearInterval(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [run]);

  return (
    <div className="bg-white/40 xl:w-[300px] w-full rounded-[15px] h-[50px] until-xl:justify-between flex flex-row gap-4 px-6 items-center">
      <p className="font-semibold text-white">Since start</p>

      <div className="flex font-semibold text-xl flex-row items-center gap-1">
        <div className="  font-semibold bg-white opacity-100 w-[40px] h-[40px]  text-center rounded-[15px] flex justify-center items-center">
          <p>{String(time?.hour).padStart(2, "0")}</p>
        </div>

        <div className="font-semibold text-white  w-fit h-[40px]  text-center rounded-[15px] flex justify-center items-center">
          <p>:</p>
        </div>

        <div className="font-semibold bg-white opacity-100   w-[40px] h-[40px]  text-center rounded-[15px] flex justify-center items-center">
          <p>{String(time?.minute).padStart(2, "0")}</p>
        </div>

        <div className="font-semibold text-white w-fit h-[40px]  text-center rounded-[15px] flex justify-center items-center">
          <p>:</p>
        </div>

        <div className="font-semibold bg-white w-[40px] h-[40px]  text-center rounded-[15px] flex justify-center items-center">
          <p>{String(time?.second).padStart(2, "0")}</p>
        </div>
      </div>
    </div>
  );
};
export default Timer;
